import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/users/roles')({
    component: RouteComponent,
})

function RouteComponent() {
    return <Outlet />
}
